export function isUserHasOperator (
  $auth
){

  'ngInject';

  return ( input ) => $auth.getUser() && $auth.getUser().operators.indexOf(input) != -1

}


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/isUserHasOperator.filter.js
 **/